module.exports = __webpack_public_path__ + "static/media/brand-refresh-caret-right.2ae379a3.svg";